import type { ReactElement } from 'react';
import { CicReports } from './CicReports';
import { CicSubmissionWizard } from './CicSubmissionWizard';
import { TaxreturnAddnewreport } from './TaxreturnAddnewreport';
import { TaxreturnCashflows } from './TaxreturnCashflows';
import { TaxreturnManagementaccounts } from './TaxreturnManagementaccounts';
import { TaxreturnReportNominalladger } from './TaxreturnReportNominalladger';
import { TaxreturnReports } from './TaxreturnReports';
import { TaxreturnReporttrialbalance } from './TaxreturnReporttrialbalance';

/** Ported screens of this slice, keyed by their Angular URL (see src/app/routeManifest.ts). */
export const screens: Record<string, ReactElement> = {
  '/home/taxreturns/reports-accounts': <TaxreturnReports />,
  '/home/taxreturns/reports-cicreports': <CicReports />,
  '/home/taxreturns/tasks-cicsubmission': <CicSubmissionWizard />,
  '/home/taxreturns/reports-managementaccounts': <TaxreturnManagementaccounts />,
  '/home/taxreturns/addnewreport': <TaxreturnAddnewreport />,
  '/home/taxreturns/reports-cashflows': <TaxreturnCashflows />,
  '/home/taxreturns/reports-trialbalance': <TaxreturnReporttrialbalance />,
  '/home/taxreturns/reports-ladger': <TaxreturnReportNominalladger />,
};
